module.exports = __webpack_public_path__ + "static/media/Baggage Lost_ Delay benefit.0879aae9.png";